module.exports = __webpack_public_path__ + "img/bg_festa9.55c78653.jpg";